module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-welcome"
  }, [_c('div', {
    staticClass: "custom-home-welcome__container"
  }, [_c('div', {
    staticClass: "custom-home-welcome__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-home-welcome__subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.props.subtitle)
    }
  }), _c('div', {
    staticClass: "custom-home-welcome__text-container"
  }, [_c('div', {
    staticClass: "custom-home-welcome__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  }), _c('a', {
    staticClass: "custom-home-welcome__button",
    attrs: {
      "href": "/mouth-guard-registration",
      "target": "_blank"
    }
  }, [_vm._v("Mouth Guard Event Registration")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58363f35","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-welcome/custom-home-welcome.pug
// module id = 705
// module chunks = 1